"use client"
import React, { useState, useEffect } from "react";
import Utils from "@/components/shared/utils";
import { Formik } from "formik";
import { Form } from "react-bootstrap";
import AutoSave from "@/components/shared/AutoSave";

import "@/components/shared/LocationAddressEntry.css";
import MaxCharacterField from "@/components/shared/MaxCharacterField";

var yup = require("yup");

const LocationAddressEntry = ({ location, onChange, onCancel }) => {
  const [theLocation, setTheLocation] = useState(null);

  useEffect(() => {
    if (location) {
      setTheLocation(location);
    }
  }, [location]);

  const submitNewLocation = values => {
    var merged = { ...theLocation, ...values };
    onChange(merged);
  };

  var schema = yup.object({
    streetAddress: yup
      .string()
      .nullable()
      .label("Street Address"),
    unitNumber: yup
      .string()
      .nullable()
      .label("Unit/Apt Number"),
    city: yup
      .string()
      .nullable()
      .label("City"),
    state: yup
      .string()
      .nullable()
      .label("State"),
    postalCode: yup
      .string()
      .nullable()
      .label("Postal Code"),
    notes: yup
      .string()
      .nullable()
      .label("Notes")
      .max(200)
  });

  var values = {
    latitude: theLocation ? theLocation.latitude : null,
    longitude: theLocation ? theLocation.longitude : null,
    streetAddress: theLocation ? theLocation.streetAddress : null,
    unitNumber: theLocation ? theLocation.unitNumber : null,
    city: theLocation ? theLocation.city : null,
    state: theLocation ? theLocation.state : null,
    postalCode: theLocation ? theLocation.postalCode : null,
    metadata: theLocation ? theLocation.metadata : null,
    notes: theLocation ? theLocation.notes : null
  };

  if (theLocation) {
    return (
      <Formik
        initialValues={values}
        enableReinitialize={true} // this needs to be true because we're not waiting for theLocation to be set prior to first render and AutoSave is being used JC 2025-08-21
        validationSchema={schema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setTimeout(() => {
            submitNewLocation(values, status => {
              setSubmitting(false);
              resetForm({ values, dirty: false });
            });
          }, 400);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          isValid,
          errors,
          touched,
          setFieldValue, // if you ever use setFieldValue you must also use setFieldTouched based on using AutoSave
          isSubmitting
        }) => {
          return (
            <Form
              id="coordinate-entry-form"
              className="no-style"
              onSubmit={handleSubmit}
            >
              <AutoSave showTimestamp={false} />
              <Form.Group controlId="streetAddress">
                <Form.Label className="small">Street Address</Form.Label>
                <Form.Control
                  type="text"
                  name="streetAddress"
                  value={values.streetAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={!!errors.streetAddress && touched.streetAddress}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.streetAddress}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="unitNumber">
                <Form.Label className="small">Unit Number</Form.Label>
                <Form.Control
                  type="text"
                  name="unitNumber"
                  value={values.unitNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={!!errors.unitNumber && touched.unitNumber}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.unitNumber}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="city">
                <Form.Label className="small">City</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={values.city}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={!!errors.city && touched.city}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.city}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="state">
                <Form.Label className="small">State</Form.Label>
                <Form.Control
                  type="text"
                  name="state"
                  value={values.state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={!!errors.state && touched.state}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.state}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="postalCode">
                <Form.Label className="small">Postal Code</Form.Label>

                <Form.Control
                  type="text"
                  name="postalCode"
                  value={values.postalCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={!!errors.postalCode && touched.postalCode}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.postalCode}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="notes">
                <Form.Label className="small">Notes</Form.Label>
                <MaxCharacterField
                  schema={schema}
                  fieldName={"notes"}
                  value={values.notes}
                  as={"textarea"}
                  rows={3}
                  placeholder="Enter Notes Here"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Form.Group>
              {values.latitude && values.longitude && (
                <div className="coordinates with-icon">
                  <span className="material-icons">location_on</span>
                  <span>{`${values.latitude},${values.longitude}`}</span>
                </div>
              )}
              {values.metadata && (
                <div className="coordinates with-icon">
                  <span>{values.metadata}</span>
                </div>
              )}
              <input type="hidden" name="latitude" value={values.latitude} />
              <input type="hidden" name="longitude" value={values.longitude} />
              {/*<Form.Group controlId="latitude">*/}
              {/*  <Form.Label>Latitude</Form.Label>*/}
              {/*  <Form.Control*/}
              {/*      type="number"*/}
              {/*      name="latitude"*/}
              {/*      value={values.latitude}*/}
              {/*      onChange={handleChange}*/}
              {/*      onBlur={handleBlur}*/}
              {/*      isInvalid={!!errors.latitude && touched.latitude}*/}
              {/*  />*/}
              {/*  <Form.Control.Feedback type="invalid">*/}
              {/*    {errors.latitude}*/}
              {/*  </Form.Control.Feedback>*/}
              {/*</Form.Group>*/}
              {/*<Form.Group controlId="longitude">*/}
              {/*  <Form.Label>Longitude</Form.Label>*/}
              {/*  <Form.Control*/}
              {/*      type="number"*/}
              {/*      name="longitude"*/}
              {/*      value={values.longitude}*/}
              {/*      onChange={handleChange}*/}
              {/*      onBlur={handleBlur}*/}
              {/*      isInvalid={!!errors.longitude && touched.longitude}*/}
              {/*  />*/}
              {/*  <Form.Control.Feedback type="invalid">*/}
              {/*    {errors.longitude}*/}
              {/*  </Form.Control.Feedback>*/}
              {/*</Form.Group>*/}
            </Form>
          );
        }}
      </Formik>
    );
  } else {
    return <></>;
  }
};
export default LocationAddressEntry;
